import _ from 'lodash';
import { common } from './messages/common';
import { dashboard } from './messages/dashboard';
import { enterSettings } from './messages/enterSettings';
import { roan } from './messages/roan';
import { replacementMessage } from './stringUtil';

// サービス種別
//  000：共通
const COMMON = '000';
//  001：調整会議
const DASHBOARD = '001';
//  002：入退場管理
const ENTER_SETTINGS = '002';
//  003：労務安全
const ROAN = '003';

/*
 * メッセージのクラス
 * このように呼ぶ
 * import { messageUtility } from '../utilities/messageUtility';
 * messageUtility.getMessage('W-000-001');
 *
 * 引数を渡してリプレースメントも可能
 * messageUtility.getMessage('W-000-001', 'hoge', 'bar', 'fuga');
 */
export const messageUtility = {
  getMessage: (messageID, ...args) => {
    if (_.isNil(messageID)) {
      throw new Error('empty id');
    }

    // 正規表現で分割
    let arr = messageID.match(/(\D+)-(\d+)-(.*)/);
    if (arr === null || arr.length !== 4) {
      throw new Error('invalid id');
    }

    // {メッセージ種別}-{サービス種別}-{番号}
    // E-002-005-02
    const messageType = arr[1];
    const serviceType = arr[2];
    const myNumber = arr[3];
    let klass = null;

    // サービス種別
    switch (serviceType) {
      case COMMON:
        klass = common;
        break;
      case DASHBOARD:
        klass = dashboard;
        break;
      case ENTER_SETTINGS:
        klass = enterSettings;
        break;
      case ROAN:
        klass = roan;
        break;
    }

    if (klass === null) {
      throw new Error('invalid service type');
    } else {
      // 実際のメッセージ
      let message = klass[messageType][myNumber];

      if (_.isNil(message)) {
        // メッセージが定義されていない
        throw new Error('undefined message');
      }

      // メッセージ内のリプレースメント確認
      // 可変長引数で受け取った値を可変長引数としてメソッドに渡すので「...」
      message = replacementMessage(message, ...args);
      return message;
    }
  },
};



// WEBPACK FOOTER //
// ./src/utilities/messageUtility.js